/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Diet_Low_CarbInputs */

const en_diet_low_carb = /** @type {(inputs: Diet_Low_CarbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Low carb`)
};

const de_diet_low_carb = /** @type {(inputs: Diet_Low_CarbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Low Carb`)
};

/**
* | output |
* | --- |
* | "Low carb" |
*
* @param {Diet_Low_CarbInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const diet_low_carb = /** @type {((inputs?: Diet_Low_CarbInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Diet_Low_CarbInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_diet_low_carb(inputs)
	return en_diet_low_carb(inputs)
});